export default __webpack_public_path__ + "479ee4d187dbddb4ca3994cba61b26fc.svg";